<style lang="less" scoped>
    .mark-el {
        width:100%;
        height: 100%;
        background: #F4F8FF;
        p {
            margin-bottom: 0px;
            font-size:14px !important;
            line-height: 21px;
            text-align: center;
        }
        .title {
           text-align: left;
           padding-top: 12px;
           padding-left: 10px;
           // line-height: 24px;
           color: #b8b8b8;
        }
        .num-contain {
            padding-top: 5px;
            padding-left: 10px;  
            padding-bottom: 5px;     
            text-align: left;   
        }
        .num {
            font-size: 20px;
            font-weight: bold;

        }
        .percent {
          font-size: 12px;
          color: #606266;
          line-height: 16px;
        }
        // .percent {
        //     padding-top: 5px;
        //     color: #b8b8b8
        // }
        .contrast {
          height: 20px;
          line-height: 20px;
          padding-left: 10px;    
          font-size: 12px;
          font-weight: 400;
          text-align: left;
          color: #F56C6C;
        }
    }
</style>
<template>
  <div class="mark-el">
    <p class="title">
      {{ markProps.title }}
    </p>
    <p class="num-contain">
      <span class="num">
        {{ markProps.num }}        
      </span>
      <span class="percent">
        {{ markProps.percent }}
      </span>
    </p>
    <p
      class="contrast"
      :style="{
        color: markProps.isRise?'red':'green'
      }"
    >
      {{ `环比上月：${markProps.toPercent}${markProps.isRise?'↑':'↓'}` }}
    </p>
  </div>
</template>
<script>
  export default {
    props: {
      markProps: {
        type:Object,
        default: () => ({})
      }
    }
  }
</script>
